import { render, staticRenderFns } from "./order_sh.vue?vue&type=template&id=b4688fca&scoped=true"
import script from "./order_sh.vue?vue&type=script&lang=js"
export * from "./order_sh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4688fca",
  null
  
)

export default component.exports